<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToBox'
});
</script>
<template>
	<div :flex="flex ? flex : null" class="to-box" :class="setClass" :style="setStyle">
		<slot></slot>
		<div class="to-box-check"></div>
	</div>
</template>

<script setup lang="ts">
import { CSSProperties, computed } from 'vue'



export interface Props {
	mode?: string
	color?: string
	padding?: string | number
	paddingPosition?: string
	height?: '' | 'full' | number | string
	checked?: boolean
	shadow?: boolean
	trigger?: 'hover' | 'always'
	clip?: boolean
	link?: boolean
	width?: string | number
	flex?: boolean
}
const props = withDefaults(defineProps<Props>(), {
	mode: 'default',
	color: 'default',
	padding: '',
	paddingPosition: '',
	height: '',
	checked: false,
	shadow: false,
	link: false,
	trigger: 'always',
	width: '',
	flex: false
})
const setClass = computed(() => {
	let arr: string[] = []
	if (props.mode) {
		arr.push(`mode-${props.mode}`)
	}
	if (props.color) {
		arr.push(`color-${props.color}`)
	}
	if (props.height && props.height === 'full') {
		arr.push('height-full')
	}
	if (props.checked) {
		arr.push('is-checked')
	}
	if (props.clip) {
		arr.push('is-clip')
	}
	if (props.link) {
		arr.push('is-link')
	}
	if (props.shadow) {
		arr.push('is-shadow')
		if (props.trigger) {
			arr.push(`trigger-${props.trigger}`)
		}
	}
	return arr
})
const setStyle = computed(() => {
	const obj: CSSProperties = {}
	if (props.height && props.height !== 'full') {
		if (!isNaN(Number(props.height))) {
			obj.height = props.height + 'em'
		} else {
			obj.height = props.height
		}
	}

	if (props.width) {
		if (!isNaN(Number(props.width))) {
			obj.width = props.width + 'em'
		} else {
			if (props.width === 'full') {
				obj.width = '100%'
			} else {
				obj.width = props.width
			}
		}
	}
	const hasUnit = (val: string) => /[a-z%]+$/i.test(val)
	if (String(props.padding).trim()) {
		// 分割成各个值
		const padded = String(props.padding)
			.trim()
			.split(/\s+/)
			.map(val => {
				return hasUnit(val) ? val : `${val}em`
			})
			.join(' ')
		obj.padding = padded
		if (props.paddingPosition && !props.paddingPosition.includes('t')) {
			obj.paddingTop = 0
		}
		if (props.paddingPosition && !props.paddingPosition.includes('r')) {
			obj.paddingRight = 0
		}
		if (props.paddingPosition && !props.paddingPosition.includes('b')) {
			obj.paddingBottom = 0
		}
		if (props.paddingPosition && !props.paddingPosition.includes('l')) {
			obj.paddingLeft = 0
		}
	}
	return obj
})
</script>
